import React from 'react';
import { Switch as ShadcnSwitch } from '@/components/ui/shadcn/switch';
import { cn } from '@/lib/utils';

export interface SwitchProps extends React.ComponentProps<typeof ShadcnSwitch> {}

function Switch({ className, ref, ...props }: SwitchProps) {
  return (
    <ShadcnSwitch
      ref={ref}
      // Project rule: clickable elements always show the pointer (the raw
      // shadcn switch has no cursor).
      // The raw shadcn off-state (bg-input track + white thumb) is invisible on
      // the light theme's white cards — give it a real border and a grey
      // unchecked track so the control reads as a toggle in both states.
      className={cn(
        'cursor-pointer border-border data-[state=unchecked]:bg-muted-foreground/40',
        className,
      )}
      {...props}
    />
  );
}

export { Switch };
